import React from 'react'
import { Select as BaseSelect } from '@chakra-ui/core'

export const Select = React.forwardRef(({ children, has_small_text = true, ...props }, ref) => (
    <BaseSelect fontSize={has_small_text && '12px'} ref={ref} {...props}>
        {children}
    </BaseSelect>
))
